import React from 'react';
import {withStyles} from '@material-ui/core';
import styles from 'components/commonStyles';
import PropTypes from 'prop-types';
import {graphql, StaticQuery} from 'gatsby';
import Img from 'gatsby-image';
import get from 'lodash/get';

const Case10 = ({classes}) => (
  <StaticQuery
    query={graphql`
      query {
        image: allFile(
          filter: { relativePath: { eq: "other/api-chooser/10.png" } }
        ) {
          edges {
            node {
              id
              childImageSharp {
                id
                fluid(
                  srcSetBreakpoints: [200, 340, 520, 800, 890]
                  quality: 100
                ) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const img = get(data, 'image.edges[0].node.childImageSharp.fluid', {});

      return (
        <div className={classes.case} id="bi-directional">
          <div className={classes.head}>
            <h4 className={classes.h4Absolute}>
              Use Case #10. Bi-directional relationships with servers
            </h4>
          </div>
          <p className={classes.textHead} style={{marginBottom: 60}}>
            You have a server with data from your POS to be integrated with
            srv4pos.com where articles/sales can come both from srv4pos and your
            server.
          </p>
          <Img fluid={img} style={{maxWidth: 705}} />
          <p style={{marginTop: 60}}>
            A full-featured master-master synchronization is used between
            srv4pos.com and regular POS as described in case Use Case #5.
            Regular POS because regular POS has own database. Use the same
            method for POS server too.
          </p>
        </div>
      );
    }}
  />
);

Case10.propTypes = {
  classes: PropTypes.shape({
    case: PropTypes.string.isRequired,
    head: PropTypes.string.isRequired,
    h4Absolute: PropTypes.string.isRequired,
    textHead: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles, {withTheme: true})(Case10);
